(function () {
    var cartBtn = document.getElementById('cartBtn');
    var toastEl = document.getElementById('toast');
    var toastTimer;
    var cartPopupEl = null;
    var cartUrl = document.body.getAttribute('data-cart-url') || '/cart';
    var checkoutUrl = document.body.getAttribute('data-checkout-url') || '/checkout';

    function t(key, vars) {
        if (window.FluxColdI18n && window.FluxColdI18n.t) {
            return window.FluxColdI18n.t(key, vars);
        }
        return key;
    }

    function showToast(message) {
        if (!toastEl) return;
        toastEl.textContent = message;
        toastEl.classList.add('is-visible');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function () {
            toastEl.classList.remove('is-visible');
        }, 3200);
    }

    function ensureCartPopup() {
        if (cartPopupEl) return cartPopupEl;
        cartPopupEl = document.createElement('div');
        cartPopupEl.id = 'cartAddedPopup';
        cartPopupEl.className = 'cart-added-popup';
        cartPopupEl.setAttribute('role', 'dialog');
        cartPopupEl.setAttribute('aria-modal', 'true');
        cartPopupEl.setAttribute('aria-labelledby', 'cartAddedPopupTitle');
        cartPopupEl.innerHTML =
            '<div class="cart-added-popup__backdrop" data-cart-popup-close></div>' +
            '<div class="cart-added-popup__panel">' +
            '  <div class="cart-added-popup__header">' +
            '    <div class="cart-added-popup__status">' +
            '      <span class="cart-added-popup__check" aria-hidden="true"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 8.5 6.5 11.5 12.5 4.5"/></svg></span>' +
            '      <span id="cartAddedPopupTitle"></span>' +
            '    </div>' +
            '    <button type="button" class="cart-added-popup__close" data-cart-popup-close>&times;</button>' +
            '  </div>' +
            '  <div class="cart-added-popup__product">' +
            '    <div class="cart-added-popup__image-wrap"><img class="cart-added-popup__image" src="" alt=""></div>' +
            '    <div class="cart-added-popup__details">' +
            '      <div class="cart-added-popup__name"></div>' +
            '      <div class="cart-added-popup__meta"></div>' +
            '      <div class="cart-added-popup__variant"></div>' +
            '      <div class="cart-added-popup__price"></div>' +
            '    </div>' +
            '  </div>' +
            '  <p class="fc-heavy-notice" data-heavy-notice hidden></p>' +
            '  <div class="cart-added-popup__actions">' +
            '    <a class="cart-added-popup__view" href="/cart"></a>' +
            '    <a class="cart-added-popup__checkout" href="/checkout"></a>' +
            '  </div>' +
            '</div>';
        document.body.appendChild(cartPopupEl);
        var closeBtn = cartPopupEl.querySelector('.cart-added-popup__close');
        if (closeBtn) closeBtn.setAttribute('aria-label', t('cart.close'));
        cartPopupEl.querySelectorAll('[data-cart-popup-close]').forEach(function (node) {
            node.addEventListener('click', hideCartPopup);
        });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') hideCartPopup();
        });
        return cartPopupEl;
    }

    function hideCartPopup() {
        if (cartPopupEl) cartPopupEl.classList.remove('is-visible');
    }

    function formatCents(cents) {
        if (typeof cents !== 'number' || isNaN(cents)) return '';
        return '$' + (cents / 100).toFixed(2);
    }

    function getProductMetaFromButton(btn) {
        var card = btn.closest('.product-card, .product-main__details');
        var meta = {
            name: btn.getAttribute('data-product') || '',
            price: btn.getAttribute('data-price-display') || '',
            description: btn.getAttribute('data-description') || '',
            image: btn.getAttribute('data-image') || '',
            variant: btn.getAttribute('data-variant-label') || ''
        };
        if (card) {
            if (!meta.name) {
                var titleEl = card.querySelector('.product-title, .product-main__title');
                if (titleEl) meta.name = titleEl.textContent.trim();
            }
            if (!meta.price) {
                var priceEl = card.querySelector('.product-price, .product-main__price');
                if (priceEl) meta.price = priceEl.textContent.trim();
            }
            if (!meta.description) {
                var descEl = card.querySelector('.product-description');
                if (descEl) meta.description = descEl.textContent.trim();
            }
            if (!meta.image) {
                var imgEl = card.querySelector('.product-image img, .product-main__media img');
                if (imgEl) meta.image = imgEl.getAttribute('src') || '';
            }
        }
        if (!meta.variant) {
            var scope = btn.closest('.product-form, .product-main__buy');
            if (scope) {
                var select = scope.querySelector('select[name="id"]');
                if (select && select.selectedOptions[0]) {
                    var label = select.selectedOptions[0].textContent.split('—')[0].trim();
                    if (label && label !== 'Default Title') meta.variant = label;
                }
            }
        }
        return meta;
    }

    function showCartAddedPopup(meta, cartCount) {
        var popup = ensureCartPopup();
        popup.querySelector('#cartAddedPopupTitle').textContent = t('cart.addedTitle');
        popup.querySelector('.cart-added-popup__close').setAttribute('aria-label', t('cart.close'));
        popup.querySelector('.cart-added-popup__name').textContent = meta.name || t('cart.item');
        var metaEl = popup.querySelector('.cart-added-popup__meta');
        metaEl.textContent = meta.description || '';
        metaEl.hidden = !meta.description;
        var variantEl = popup.querySelector('.cart-added-popup__variant');
        variantEl.textContent = meta.variant || '';
        variantEl.hidden = !meta.variant;
        popup.querySelector('.cart-added-popup__price').textContent = meta.price || '';
        var imageEl = popup.querySelector('.cart-added-popup__image');
        imageEl.src = meta.image || '';
        imageEl.alt = meta.name || '';
        popup.querySelector('.cart-added-popup__image-wrap').hidden = !meta.image;
        popup.querySelector('.cart-added-popup__view').textContent = t('cart.viewCart', { count: cartCount });
        popup.querySelector('.cart-added-popup__view').setAttribute('href', cartUrl);
        popup.querySelector('.cart-added-popup__checkout').textContent = t('cart.checkout');
        popup.querySelector('.cart-added-popup__checkout').setAttribute('href', checkoutUrl);
        popup.querySelector('.cart-added-popup__view').onclick = null;
        popup.querySelector('.cart-added-popup__checkout').onclick = null;
        popup.classList.add('is-visible');
    }

    /* Large-order notice (> 20 lb). Reads total_weight (grams) from /cart.js after every cart change. */
    function updateHeavyNotice(cart) {
        if (!cart || typeof cart.total_weight !== 'number') return;
        var limit = parseInt(document.body.getAttribute('data-heavy-grams'), 10) || 9072;
        var url = document.body.getAttribute('data-heavy-url') || '/products/fluxcold-flexible-ice-blanket-16x9#quote-form';
        var over = cart.total_weight > limit;
        document.querySelectorAll('[data-heavy-notice]').forEach(function (el) {
            if (!el.firstChild) {
                el.appendChild(document.createTextNode("Large order? Express shipping isn't available over 20 lb. "));
                var a = document.createElement('a');
                a.href = url;
                a.textContent = 'Request a bulk quote \u2192';
                el.appendChild(a);
            }
            el.hidden = !over;
        });
    }

    function updateCartFromServer() {
        return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (r) {
                return r.json();
            })
            .then(function (cart) {
                if (cartBtn) {
                    cartBtn.textContent = t('nav.cart', { count: cart.item_count });
                }
                updateHeavyNotice(cart);
                return cart;
            })
            .catch(function () {
                return { item_count: 1 };
            });
    }

    function scrollToId(id) {
        var el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
    }

    function goToProducts() {
        if (document.getElementById('products')) {
            scrollToId('products');
            return;
        }
        var url = document.body.getAttribute('data-products-url') || '/collections/all';
        window.location.href = url;
    }

    var heroShop = document.getElementById('heroShopBtn');
    var heroLearn = document.getElementById('heroLearnBtn');
    var viewFeatures = document.getElementById('viewFeaturesBtn');
    var ctaShop = document.getElementById('ctaShopBtn');
    if (heroShop) heroShop.addEventListener('click', goToProducts);
    if (heroLearn) heroLearn.addEventListener('click', function () { scrollToId('features'); });
    if (viewFeatures) {
        viewFeatures.addEventListener('click', function () {
            scrollToId('features');
        });
    }
    if (ctaShop) ctaShop.addEventListener('click', goToProducts);

    (function initHeroCarousel() {
        var carousel = document.querySelector('[data-hero-carousel]');
        if (!carousel) return;
        var slides = carousel.querySelectorAll('[data-hero-slide]');
        if (slides.length < 2) return;
        var dots = document.querySelectorAll('[data-hero-dot]');
        var visual = carousel.closest('.hero-visual');
        var tiltStage = document.querySelector('[data-hero-tilt]');
        var CAROUSEL_MS = 4500;
        var index = 0;
        var timer = null;
        var tiltEnabled = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

        function restartKenBurns(slide) {
            if (!slide) return;
            var img = slide.querySelector('img');
            if (!img) return;
            img.style.animation = 'none';
            void img.offsetWidth;
            img.style.animation = '';
        }

        function setSlide(nextIndex) {
            index = ((nextIndex % slides.length) + slides.length) % slides.length;
            slides.forEach(function (slide, i) {
                slide.classList.toggle('is-active', i === index);
            });
            dots.forEach(function (dot, i) {
                var active = i === index;
                dot.classList.toggle('is-active', active);
                dot.setAttribute('aria-selected', active ? 'true' : 'false');
            });
            restartKenBurns(slides[index]);
        }

        function stopCarousel() {
            if (timer) {
                clearInterval(timer);
                timer = null;
            }
        }

        function startCarousel() {
            stopCarousel();
            timer = setInterval(function () {
                setSlide(index + 1);
            }, CAROUSEL_MS);
        }

        dots.forEach(function (dot) {
            dot.addEventListener('click', function () {
                setSlide(Number(dot.getAttribute('data-hero-dot')));
                startCarousel();
            });
        });

        if (visual) {
            visual.addEventListener('mouseenter', stopCarousel);
            visual.addEventListener('mouseleave', function () {
                startCarousel();
                if (tiltStage) tiltStage.style.transform = '';
            });
        }

        if (tiltStage && visual && tiltEnabled) {
            visual.addEventListener('mousemove', function (e) {
                var rect = visual.getBoundingClientRect();
                var x = (e.clientX - rect.left) / rect.width - 0.5;
                var y = (e.clientY - rect.top) / rect.height - 0.5;
                tiltStage.style.transform =
                    'rotateY(' + (x * 16).toFixed(2) + 'deg) rotateX(' + (-y * 12).toFixed(2) + 'deg) translateZ(12px)';
            });
        }

        setSlide(0);
        startCarousel();
    })();

    function getVariantId(btn) {
        var vid = btn.getAttribute('data-variant-id');
        if (vid && /^\d+$/.test(String(vid).trim())) {
            return parseInt(vid, 10);
        }
        var scope = btn.closest('.product-main__buy, .product-card, .product-form, form');
        if (scope) {
            var input = scope.querySelector('[name="id"]');
            if (input && input.value && /^\d+$/.test(String(input.value).trim())) {
                return parseInt(input.value, 10);
            }
        }
        return null;
    }

    function addToCart(btn) {
        if (btn.disabled) return;
        var variantId = getVariantId(btn);
        var meta = getProductMetaFromButton(btn);
        if (!variantId) {
            showToast(meta.name ? meta.name + ': ' + t('cart.variantRequired') : t('cart.variantRequired'));
            return;
        }
        btn.disabled = true;
        fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
            .then(function (r) {
                if (!r.ok) throw new Error('Cart add failed');
                return r.json();
            })
            .then(function (response) {
                var lineItem = response && response.items ? response.items[0] : response;
                if (lineItem && lineItem.product_title) meta.name = lineItem.product_title;
                if (lineItem && lineItem.variant_title && lineItem.variant_title !== 'Default Title') {
                    meta.variant = lineItem.variant_title;
                }
                if (lineItem && lineItem.image) meta.image = lineItem.image;
                if (lineItem && lineItem.price) meta.price = formatCents(lineItem.price);
                return updateCartFromServer().then(function (cart) {
                    showCartAddedPopup(meta, cart.item_count);
                    updateHeavyNotice(cart);
                });
            })
            .catch(function () {
                showToast(t('cart.couldNotAdd'));
            })
            .finally(function () {
                btn.disabled = false;
            });
    }

    if (document.querySelector('[data-heavy-notice]') || document.getElementById('cart-form')) {
        window.addEventListener('pageshow', function () { updateCartFromServer(); });
    }
    document.addEventListener('cart:updated', function () { updateCartFromServer(); });

    document.querySelectorAll('.btn-add-cart').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            addToCart(btn);
        });
    });

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            var btn = form.querySelector('.btn-add-cart, [name="add"], button[type="submit"]');
            if (btn) addToCart(btn);
        });
    });

    var quoteForm = document.getElementById('ProductQuoteForm');
    if (quoteForm) {
        quoteForm.addEventListener('submit', function () {
            var body = document.getElementById('QuoteFormBody');
            if (!body) return;
            function field(name) {
                var el = quoteForm.querySelector('[name="' + name + '"]');
                return el && el.value ? String(el.value).trim() : '';
            }
            body.value = [
                'Quote request for ' + field('contact[product]'),
                'Product URL: ' + field('contact[product_url]'),
                'Name / Company: ' + field('contact[name]'),
                'Email: ' + field('contact[email]'),
                'Phone: ' + field('contact[phone]'),
                'Quantity: ' + field('contact[quantity]')
            ].join('\n');
        });
        var quoteSuccess = quoteForm.querySelector('.quote-form__success');
        if (quoteSuccess) {
            quoteSuccess.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    var newsletterForm = document.getElementById('newsletterForm');
    if (newsletterForm) {
        newsletterForm.addEventListener('submit', function (e) {
            e.preventDefault();
            var input = document.getElementById('newsletter-email');
            showToast(t('newsletter.toast'));
            if (input) input.value = '';
        });
    }

    var navToggle = document.getElementById('navToggle');
    var primaryNav = document.getElementById('primary-nav');
    function setNavToggleLabel(open) {
        if (!navToggle) return;
        navToggle.setAttribute('aria-label', open ? t('a11y.closeMenu') : t('a11y.openMenu'));
    }
    function refreshLangSwitchThumb() {
        if (window.FluxColdI18n && window.FluxColdI18n.positionThumb) {
            if (typeof requestAnimationFrame === 'function') {
                requestAnimationFrame(window.FluxColdI18n.positionThumb);
            } else {
                window.FluxColdI18n.positionThumb();
            }
        }
    }

    if (navToggle && primaryNav) {
        navToggle.addEventListener('click', function () {
            var open = !primaryNav.classList.contains('is-open');
            primaryNav.classList.toggle('is-open', open);
            navToggle.setAttribute('aria-expanded', open);
            setNavToggleLabel(open);
            if (open) refreshLangSwitchThumb();
        });

        primaryNav.querySelectorAll('a').forEach(function (link) {
            link.addEventListener('click', function () {
                primaryNav.classList.remove('is-open');
                navToggle.setAttribute('aria-expanded', 'false');
                setNavToggleLabel(false);
            });
        });
    }

    document.querySelectorAll('.faq-item[data-faq]').forEach(function (item) {
        var b = item.querySelector('button');
        var panel = item.querySelector('.faq-panel');
        if (!b || !panel) return;
        b.addEventListener('click', function () {
            var isOpen = item.classList.toggle('is-open');
            b.setAttribute('aria-expanded', isOpen);
            panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0';
        });
    });

    var thumbs = document.querySelector('.product-main__thumbs');
    var mainImg = document.getElementById('ProductMainImageImg');
    if (thumbs && mainImg) {
        thumbs.addEventListener('click', function (e) {
            var btn = e.target.closest('.product-main__thumb');
            if (!btn) return;
            var src = btn.getAttribute('data-src');
            var alt = btn.getAttribute('data-alt') || '';
            if (src) mainImg.setAttribute('src', src);
            mainImg.setAttribute('alt', alt);
            thumbs.querySelectorAll('.product-main__thumb').forEach(function (t) {
                t.classList.remove('is-active');
                t.setAttribute('aria-selected', 'false');
            });
            btn.classList.add('is-active');
            btn.setAttribute('aria-selected', 'true');
        });
    }

    var buyWrap = document.querySelector('.product-main__buy');
    var openTab = document.getElementById('productOpenNewTab');
    var variantSelect = document.querySelector('.product-form__select[name="id"]');
    var addBtn = document.querySelector('.product-main__buy .btn-add-cart');
    if (buyWrap && openTab && variantSelect) {
        var productUrl = buyWrap.getAttribute('data-product-url');
        variantSelect.addEventListener('change', function () {
            openTab.setAttribute('href', productUrl + '?variant=' + encodeURIComponent(variantSelect.value));
            if (addBtn) {
                addBtn.setAttribute('data-variant-id', variantSelect.value);
                var label = variantSelect.selectedOptions[0].textContent.split('—')[0].trim();
                addBtn.setAttribute('data-variant-label', label !== 'Default Title' ? label : '');
            }
        });
    }

    var productGrid = document.getElementById('fluxcold-product-grid');
    var expandBtn = document.getElementById('fluxcold-products-expand');
    if (productGrid && expandBtn) {
        var labelMore = expandBtn.getAttribute('data-label-more') || t('products.seeMore');
        var labelLess = expandBtn.getAttribute('data-label-less') || t('products.seeLess');
        expandBtn.addEventListener('click', function () {
            productGrid.classList.toggle('is-collapsed');
            var collapsed = productGrid.classList.contains('is-collapsed');
            expandBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
            expandBtn.textContent = collapsed ? labelMore : labelLess;
        });
    }

    var testimonialScroll = document.getElementById('fluxcold-testimonials-scroll');
    var testimonialPrev = document.querySelector('.testimonials-scroll-btn--prev');
    var testimonialNext = document.querySelector('.testimonials-scroll-btn--next');
    if (testimonialScroll && testimonialPrev && testimonialNext) {
        function testimonialStep(dir) {
            var w = testimonialScroll.clientWidth;
            var delta = Math.max(200, Math.round(w * 0.92));
            testimonialScroll.scrollBy({ left: dir * delta, behavior: 'smooth' });
        }
        testimonialPrev.addEventListener('click', function () {
            testimonialStep(-1);
        });
        testimonialNext.addEventListener('click', function () {
            testimonialStep(1);
        });
    }

    var reviewsRoot = document.querySelector('.product-reviews');
    if (reviewsRoot) {
        var productHandle = reviewsRoot.getAttribute('data-product-handle') || 'product';
        var storageKey = 'fluxcold-reviews-' + productHandle;
        var helpfulKey = 'fluxcold-review-helpful-' + productHandle;
        var listEl = reviewsRoot.querySelector('[data-reviews-list]');
        var sortEl = reviewsRoot.querySelector('[data-reviews-sort]');
        var modalEl = reviewsRoot.querySelector('[data-reviews-modal]');
        var formEl = reviewsRoot.querySelector('[data-reviews-form]');
        var ratingInput = reviewsRoot.querySelector('[data-rating-input]');
        var starButtons = reviewsRoot.querySelectorAll('[data-star-value]');
        var emptyEl = reviewsRoot.querySelector('[data-reviews-empty]');
        var isCustomerVerified = !!reviewsRoot.querySelector('[data-author-input][type="hidden"]');

        function isTestReview(review) {
            if (!review) return true;
            var author = String(review.author || '').trim().toLowerCase();
            var title = String(review.title || '').trim().toLowerCase();
            var body = String(review.body || '').trim().toLowerCase();
            return author === 'ben' || (title === 'best' && body === 'test');
        }

        function readStoredReviews() {
            try {
                var raw = localStorage.getItem(storageKey);
                var items = raw ? JSON.parse(raw) : [];
                var cleaned = items.filter(function (review) {
                    return !isTestReview(review);
                });
                if (cleaned.length !== items.length) {
                    writeStoredReviews(cleaned);
                }
                return cleaned;
            } catch (e) {
                return [];
            }
        }

        function writeStoredReviews(items) {
            try {
                localStorage.setItem(storageKey, JSON.stringify(items));
            } catch (e) {}
        }

        function readHelpfulVotes() {
            try {
                var raw = localStorage.getItem(helpfulKey);
                return raw ? JSON.parse(raw) : {};
            } catch (e) {
                return {};
            }
        }

        function writeHelpfulVotes(map) {
            try {
                localStorage.setItem(helpfulKey, JSON.stringify(map));
            } catch (e) {}
        }

        function formatMonthYear(isoDate) {
            var d = new Date(isoDate);
            if (isNaN(d.getTime())) return isoDate;
            return d.toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
        }

        function escapeHtml(str) {
            return String(str)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        }

        function getReviewNodes() {
            return Array.prototype.slice.call(listEl.querySelectorAll('.product-review'));
        }

        function paintStars(container, average) {
            if (!container) return;
            container.querySelectorAll('.product-review__star, .product-main__reviews-star').forEach(function (star, idx) {
                star.classList.toggle('is-filled', average && (idx + 1) <= Math.round(average));
            });
        }

        function updateSummary() {
            var nodes = getReviewNodes();
            var total = nodes.length;
            var sum = 0;
            var bars = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };

            nodes.forEach(function (node) {
                var rating = Number(node.getAttribute('data-rating')) || 0;
                sum += rating;
                if (bars[rating] != null) bars[rating] += 1;
            });

            var average = total ? (sum / total) : 0;

            reviewsRoot.querySelectorAll('[data-reviews-count]').forEach(function (el) {
                el.textContent = String(total);
            });
            reviewsRoot.querySelectorAll('[data-reviews-count-label]').forEach(function (el) {
                el.textContent = total === 1 ? t('productReviews.reviewSingular') : t('productReviews.reviewsLabel');
            });

            var avgEl = reviewsRoot.querySelector('[data-reviews-average]');
            if (avgEl) avgEl.textContent = total ? average.toFixed(1) : '—';

            paintStars(reviewsRoot.querySelector('[data-reviews-stars]'), average);

            [5, 4, 3, 2, 1].forEach(function (level) {
                var count = bars[level] || 0;
                var pct = total ? Math.round((count / total) * 100) : 0;
                var fill = reviewsRoot.querySelector('[data-bar-fill="' + level + '"]');
                if (fill) fill.style.width = pct + '%';
            });

            var teaserAverage = document.querySelector('[data-reviews-teaser-average]');
            var teaserCount = document.querySelector('[data-reviews-teaser-count]');
            var teaserStars = document.querySelector('[data-reviews-teaser-stars]');
            if (teaserAverage) teaserAverage.textContent = total ? average.toFixed(1) : '—';
            if (teaserCount) teaserCount.textContent = total ? String(total) : '—';
            paintStars(teaserStars, average);

            if (emptyEl) emptyEl.hidden = total > 0;
        }

        function sortReviews(mode) {
            var items = getReviewNodes().map(function (node) {
                return {
                    rating: Number(node.getAttribute('data-rating')) || 0,
                    date: node.getAttribute('data-date') || '',
                    helpful: Number(node.getAttribute('data-helpful')) || 0,
                    node: node
                };
            });
            items.sort(function (a, b) {
                if (mode === 'newest') return b.date.localeCompare(a.date);
                if (mode === 'highest') return b.rating - a.rating || b.date.localeCompare(a.date);
                if (mode === 'lowest') return a.rating - b.rating || b.date.localeCompare(a.date);
                return b.helpful - a.helpful || b.date.localeCompare(a.date);
            });
            items.forEach(function (item) {
                listEl.appendChild(item.node);
            });
        }

        function buildReviewHtml(review) {
            var stars = '';
            for (var i = 1; i <= 5; i++) {
                stars += '<span class="product-review__star' + (i <= review.rating ? ' is-filled' : '') + '" aria-hidden="true">★</span>';
            }
            var verified = review.verified
                ? '<span class="product-review__verified"><svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M6.2 10.6 4.1 8.5l-.9.9 3 3 6.5-6.5-.9-.9-5.6 5.6z"/></svg><span data-i18n="productReviews.verifiedBuyer">' + escapeHtml(t('productReviews.verifiedBuyer')) + '</span></span>'
                : '';
            var helpful = review.helpful > 0
                ? ' (<span data-helpful-count="yes">' + review.helpful + '</span>)'
                : '<span data-helpful-count="yes" hidden>0</span>';
            return (
                '<article class="product-review" data-review-id="' + escapeHtml(review.id) + '" data-rating="' + review.rating + '" data-date="' + escapeHtml(review.date) + '" data-helpful="' + (review.helpful || 0) + '" data-verified="' + (review.verified ? 'true' : 'false') + '">' +
                '<header class="product-review__header"><div class="product-review__meta"><span class="product-review__author">' + escapeHtml(review.author) + '</span>' + verified + '</div>' +
                '<time class="product-review__date" datetime="' + escapeHtml(review.date) + '">' + escapeHtml(review.displayDate) + '</time></header>' +
                '<div class="product-review__stars" aria-label="' + escapeHtml(t('productReviews.starsAria', { rating: review.rating })) + '">' + stars + '</div>' +
                '<h3 class="product-review__title">' + escapeHtml(review.title) + '</h3>' +
                '<div class="product-review__body">' + escapeHtml(review.body) + '</div>' +
                '<div class="product-review__footer"><button type="button" class="product-review__helpful-btn" data-helpful="yes" aria-label="' + escapeHtml(t('productReviews.markHelpful')) + '"><span data-i18n="productReviews.helpful">' + escapeHtml(t('productReviews.helpful')) + '</span>' + helpful + '</button></div></article>'
            );
        }

        function restoreHelpfulVotes() {
            var votes = readHelpfulVotes();
            getReviewNodes().forEach(function (review) {
                var id = review.getAttribute('data-review-id');
                if (votes[id + ':yes']) {
                    var btn = review.querySelector('[data-helpful="yes"]');
                    if (btn) btn.classList.add('is-active');
                }
            });
        }

        function purgeTestReviewNodes() {
            getReviewNodes().forEach(function (node) {
                var authorEl = node.querySelector('.product-review__author');
                var titleEl = node.querySelector('.product-review__title');
                var bodyEl = node.querySelector('.product-review__body');
                if (!authorEl || !titleEl || !bodyEl) return;
                if (isTestReview({
                    author: authorEl.textContent.trim(),
                    title: titleEl.textContent.trim(),
                    body: bodyEl.textContent.trim()
                })) {
                    node.remove();
                }
            });
        }

        function getSeedReviews() {
            var title = reviewsRoot.getAttribute('data-product-title') || '';
            if (window.FluxColdReviewSeeds && typeof window.FluxColdReviewSeeds.get === 'function') {
                return window.FluxColdReviewSeeds.get(productHandle, title);
            }
            return [];
        }

        function appendReview(review) {
            if (listEl.querySelector('[data-review-id="' + review.id + '"]')) return;
            listEl.insertAdjacentHTML('beforeend', buildReviewHtml(review));
        }

        function refreshReviewAccessibility() {
            getReviewNodes().forEach(function (node) {
                var rating = Number(node.getAttribute('data-rating')) || 0;
                var starsEl = node.querySelector('.product-review__stars');
                if (starsEl) starsEl.setAttribute('aria-label', t('productReviews.starsAria', { rating: rating }));
                var helpfulBtn = node.querySelector('[data-helpful="yes"]');
                if (helpfulBtn) helpfulBtn.setAttribute('aria-label', t('productReviews.markHelpful'));
            });
        }

        function mountProductReviews() {
            purgeTestReviewNodes();

            getSeedReviews().forEach(function (review) {
                appendReview(review);
            });

            readStoredReviews().forEach(function (review) {
                appendReview(review);
            });

            restoreHelpfulVotes();
            updateSummary();
            sortReviews(sortEl ? sortEl.value : 'newest');
            refreshReviewAccessibility();
        }

        function openModal() {
            if (!modalEl) return;
            modalEl.classList.add('is-open');
            document.body.style.overflow = 'hidden';
        }

        function closeModal() {
            if (!modalEl) return;
            modalEl.classList.remove('is-open');
            document.body.style.overflow = '';
        }

        function setStarValue(value) {
            if (ratingInput) ratingInput.value = value ? String(value) : '';
            starButtons.forEach(function (btn) {
                var v = Number(btn.getAttribute('data-star-value'));
                btn.classList.toggle('is-active', value && v <= value);
            });
        }

        reviewsRoot.querySelectorAll('[data-reviews-open]').forEach(function (btn) {
            btn.addEventListener('click', openModal);
        });
        reviewsRoot.querySelectorAll('[data-reviews-close]').forEach(function (btn) {
            btn.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') closeModal();
        });

        starButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                setStarValue(Number(btn.getAttribute('data-star-value')));
            });
        });

        if (sortEl) {
            sortEl.addEventListener('change', function () {
                sortReviews(sortEl.value);
            });
        }

        listEl.addEventListener('click', function (e) {
            var helpfulBtn = e.target.closest('[data-helpful="yes"]');
            if (!helpfulBtn) return;
            var review = helpfulBtn.closest('.product-review');
            if (!review) return;
            var reviewId = review.getAttribute('data-review-id');
            var votes = readHelpfulVotes();
            if (votes[reviewId + ':yes']) {
                showToast(t('productReviews.alreadyMarked'));
                return;
            }
            votes[reviewId + ':yes'] = true;
            writeHelpfulVotes(votes);
            var countEl = helpfulBtn.querySelector('[data-helpful-count="yes"]');
            if (countEl) {
                if (countEl.hidden) {
                    countEl.hidden = false;
                    countEl.textContent = '1';
                } else {
                    countEl.textContent = String((Number(countEl.textContent) || 0) + 1);
                }
            } else {
                helpfulBtn.appendChild(document.createTextNode(' ('));
                var span = document.createElement('span');
                span.setAttribute('data-helpful-count', 'yes');
                span.textContent = '1';
                helpfulBtn.appendChild(span);
                helpfulBtn.appendChild(document.createTextNode(')'));
            }
            helpfulBtn.classList.add('is-active');
            var current = Number(review.getAttribute('data-helpful')) || 0;
            review.setAttribute('data-helpful', String(current + 1));
            sortReviews(sortEl ? sortEl.value : 'newest');
        });

        if (formEl) {
            formEl.addEventListener('submit', function (e) {
                e.preventDefault();
                var rating = Number(ratingInput && ratingInput.value);
                var title = formEl.querySelector('[name="title"]').value.trim();
                var body = formEl.querySelector('[name="body"]').value.trim();
                var authorInput = formEl.querySelector('[data-author-input]');
                var author = authorInput ? authorInput.value.trim() : '';
                if (!rating || !title || !body || !author) {
                    showToast(t('productReviews.completeFields'));
                    return;
                }
                var now = new Date().toISOString().slice(0, 10);
                var review = {
                    id: 'local-' + Date.now(),
                    rating: rating,
                    title: title,
                    body: body,
                    author: author,
                    date: now,
                    displayDate: formatMonthYear(now),
                    verified: isCustomerVerified,
                    helpful: 0
                };
                var stored = readStoredReviews();
                stored.unshift(review);
                writeStoredReviews(stored);
                appendReview(review);
                updateSummary();
                sortReviews(sortEl ? sortEl.value : 'newest');
                formEl.reset();
                setStarValue(0);
                closeModal();
                showToast(t('productReviews.thanksLive'));
            });
        }

        mountProductReviews();

        document.addEventListener('fluxcold:langchange', function () {
            updateSummary();
            refreshReviewAccessibility();
        });
    }

    function copyPromoCode(code, btn) {
        function onCopied() {
            showToast(t('exitOffer.codeCopied', { code: code }));
            if (btn) {
                var prev = btn.textContent;
                btn.textContent = t('exitOffer.copied');
                setTimeout(function () {
                    btn.textContent = prev;
                }, 1800);
            }
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(onCopied).catch(function () {
                fallbackCopyPromo(code, onCopied);
            });
        } else {
            fallbackCopyPromo(code, onCopied);
        }
    }

    function fallbackCopyPromo(code, done) {
        var input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'absolute';
        input.style.left = '-9999px';
        document.body.appendChild(input);
        input.select();
        try {
            document.execCommand('copy');
            done();
        } catch (err) {
            showToast(t('exitOffer.copyCode', { code: code }));
        }
        document.body.removeChild(input);
    }

    updateCartFromServer();

    document.addEventListener('fluxcold:langchange', function () {
        updateCartFromServer();
        if (navToggle && primaryNav) {
            setNavToggleLabel(primaryNav.classList.contains('is-open'));
        }
        if (cartPopupEl && cartPopupEl.classList.contains('is-visible')) {
            var countMatch = (cartPopupEl.querySelector('.cart-added-popup__view').textContent || '').match(/\((\d+)\)/);
            var count = countMatch ? countMatch[1] : '0';
            cartPopupEl.querySelector('#cartAddedPopupTitle').textContent = t('cart.addedTitle');
            cartPopupEl.querySelector('.cart-added-popup__close').setAttribute('aria-label', t('cart.close'));
            cartPopupEl.querySelector('.cart-added-popup__view').textContent = t('cart.viewCart', { count: count });
            cartPopupEl.querySelector('.cart-added-popup__checkout').textContent = t('cart.checkout');
        }
    });

    (function initExitOfferPopup() {
        var DISCOUNT_CODE = 'B7XHHXPB1W80';
        var STORAGE_KEY = 'fluxcold_exit_offer_seen';
        var MIN_DWELL_MS = 3000;
        var CAROUSEL_MS = 3800;
        var SLIDE_META = [
            { captionKey: 'exitOffer.captions.0', altKey: 'heroSlides.slide1' },
            { captionKey: 'exitOffer.captions.1', altKey: 'heroSlides.slide2' },
            { captionKey: 'exitOffer.captions.2', altKey: 'heroSlides.slide3' },
            { captionKey: 'exitOffer.captions.3', altKey: 'heroSlides.slide4' }
        ];
        var exitPopupEl = null;
        var armed = false;
        var shown = false;
        var carouselTimer = null;
        var carouselIndex = 0;

        if (sessionStorage.getItem(STORAGE_KEY)) return;
        if (document.body.classList.contains('template-cart') && document.getElementById('cart-form')) return;
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

        function markSeen() {
            sessionStorage.setItem(STORAGE_KEY, '1');
        }

        function getSlideSources() {
            var raw = document.body.getAttribute('data-exit-offer-images');
            if (raw) {
                return raw.split('|').filter(Boolean);
            }
            return [
                'assets/lifestyle-cooler.png',
                'assets/hero-sheets.png',
                'assets/product-collage.png'
            ];
        }

        function getSlideMeta(i) {
            var spec = SLIDE_META[i] || { captionKey: '', altKey: 'a11y.productPhotos' };
            var captions = [
                t('exitOffer.captions.0'),
                t('exitOffer.captions.1'),
                t('exitOffer.captions.2'),
                t('exitOffer.captions.3')
            ];
            return {
                caption: captions[i] || '',
                alt: t(spec.altKey)
            };
        }

        function buildCarouselHtml() {
            var sources = getSlideSources();
            var slidesHtml = sources.map(function (src, i) {
                var meta = getSlideMeta(i);
                return (
                    '<div class="exit-offer-popup__slide' + (i === 0 ? ' is-active' : '') + '" data-exit-offer-slide="' + i + '">' +
                    '  <img src="' + src + '" alt="' + meta.alt + '" loading="lazy">' +
                    '  <p class="exit-offer-popup__caption">' + meta.caption + '</p>' +
                    '</div>'
                );
            }).join('');
            var dotsHtml = sources.map(function (_src, i) {
                return '<button type="button" class="exit-offer-popup__dot' + (i === 0 ? ' is-active' : '') + '" data-exit-offer-dot="' + i + '" aria-label="' + t('a11y.showPhoto', { n: i + 1 }) + '"></button>';
            }).join('');
            return (
                '<div class="exit-offer-popup__visual">' +
                '  <div class="exit-offer-popup__carousel" data-exit-offer-carousel>' + slidesHtml + '</div>' +
                '  <div class="exit-offer-popup__dots">' + dotsHtml + '</div>' +
                '</div>'
            );
        }

        function setCarouselSlide(index) {
            if (!exitPopupEl) return;
            var slides = exitPopupEl.querySelectorAll('[data-exit-offer-slide]');
            var dots = exitPopupEl.querySelectorAll('[data-exit-offer-dot]');
            if (!slides.length) return;
            carouselIndex = ((index % slides.length) + slides.length) % slides.length;
            slides.forEach(function (slide, i) {
                slide.classList.toggle('is-active', i === carouselIndex);
            });
            dots.forEach(function (dot, i) {
                dot.classList.toggle('is-active', i === carouselIndex);
            });
        }

        function stopCarousel() {
            if (carouselTimer) {
                clearInterval(carouselTimer);
                carouselTimer = null;
            }
        }

        function startCarousel() {
            stopCarousel();
            var slides = exitPopupEl && exitPopupEl.querySelectorAll('[data-exit-offer-slide]');
            if (!slides || slides.length < 2) return;
            carouselTimer = setInterval(function () {
                setCarouselSlide(carouselIndex + 1);
            }, CAROUSEL_MS);
        }

        function refreshExitPopupCopy() {
            if (!exitPopupEl) return;
            var badge = exitPopupEl.querySelector('.exit-offer-popup__badge');
            if (badge) badge.innerHTML = t('exitOffer.badge');
            var title = exitPopupEl.querySelector('.exit-offer-popup__title');
            if (title) title.textContent = t('exitOffer.title');
            var subtitle = exitPopupEl.querySelector('.exit-offer-popup__subtitle');
            if (subtitle) subtitle.textContent = t('exitOffer.subtitle');
            var copyBtn = exitPopupEl.querySelector('[data-exit-offer-copy]');
            if (copyBtn && copyBtn.textContent !== t('exitOffer.copied')) copyBtn.textContent = t('exitOffer.copy');
            var claimBtn = exitPopupEl.querySelector('[data-exit-offer-claim]');
            if (claimBtn) claimBtn.textContent = t('exitOffer.claim');
            exitPopupEl.querySelectorAll('.exit-offer-popup__dismiss').forEach(function (btn) {
                btn.textContent = t('exitOffer.dismiss');
            });
            var closeBtn = exitPopupEl.querySelector('.exit-offer-popup__close');
            if (closeBtn) closeBtn.setAttribute('aria-label', t('cart.close'));
            exitPopupEl.querySelectorAll('.exit-offer-popup__caption').forEach(function (el, i) {
                el.textContent = getSlideMeta(i).caption;
            });
            exitPopupEl.querySelectorAll('[data-exit-offer-dot]').forEach(function (dot, i) {
                dot.setAttribute('aria-label', t('a11y.showPhoto', { n: i + 1 }));
            });
        }

        function ensureExitPopup() {
            if (exitPopupEl) {
                refreshExitPopupCopy();
                return exitPopupEl;
            }
            exitPopupEl = document.createElement('div');
            exitPopupEl.id = 'exitOfferPopup';
            exitPopupEl.className = 'exit-offer-popup';
            exitPopupEl.setAttribute('role', 'dialog');
            exitPopupEl.setAttribute('aria-modal', 'true');
            exitPopupEl.setAttribute('aria-labelledby', 'exitOfferPopupTitle');
            exitPopupEl.innerHTML =
                '<div class="exit-offer-popup__backdrop" data-exit-offer-close></div>' +
                '<div class="exit-offer-popup__panel">' +
                buildCarouselHtml() +
                '  <div class="exit-offer-popup__content">' +
                '    <button type="button" class="exit-offer-popup__close" data-exit-offer-close>&times;</button>' +
                '    <span class="exit-offer-popup__badge"></span>' +
                '    <h2 class="exit-offer-popup__title" id="exitOfferPopupTitle"></h2>' +
                '    <p class="exit-offer-popup__subtitle"></p>' +
                '    <div class="exit-offer-popup__code-row">' +
                '      <div class="exit-offer-popup__code" data-exit-offer-code>' + DISCOUNT_CODE + '</div>' +
                '      <button type="button" class="exit-offer-popup__copy" data-exit-offer-copy></button>' +
                '    </div>' +
                '    <a class="exit-offer-popup__claim" data-exit-offer-claim href="/discount/' + DISCOUNT_CODE + '"></a>' +
                '    <button type="button" class="exit-offer-popup__dismiss" data-exit-offer-close></button>' +
                '  </div>' +
                '</div>';
            document.body.appendChild(exitPopupEl);
            refreshExitPopupCopy();

            exitPopupEl.querySelectorAll('[data-exit-offer-close]').forEach(function (node) {
                node.addEventListener('click', hideExitPopup);
            });

            exitPopupEl.querySelectorAll('[data-exit-offer-dot]').forEach(function (dot) {
                dot.addEventListener('click', function () {
                    setCarouselSlide(Number(dot.getAttribute('data-exit-offer-dot')));
                    startCarousel();
                });
            });

            var visual = exitPopupEl.querySelector('.exit-offer-popup__visual');
            if (visual) {
                visual.addEventListener('mouseenter', stopCarousel);
                visual.addEventListener('mouseleave', startCarousel);
            }

            var copyBtn = exitPopupEl.querySelector('[data-exit-offer-copy]');
            if (copyBtn) {
                copyBtn.addEventListener('click', function () {
                    copyPromoCode(DISCOUNT_CODE, copyBtn);
                });
            }

            var claimBtn = exitPopupEl.querySelector('[data-exit-offer-claim]');
            if (claimBtn) {
                claimBtn.addEventListener('click', function () {
                    markSeen();
                });
            }

            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && exitPopupEl && exitPopupEl.classList.contains('is-visible')) {
                    hideExitPopup();
                }
            });

            return exitPopupEl;
        }

        function showExitPopup() {
            if (shown || sessionStorage.getItem(STORAGE_KEY)) return;
            shown = true;
            markSeen();
            var popup = ensureExitPopup();
            popup.classList.add('is-visible');
            document.body.style.overflow = 'hidden';
            setCarouselSlide(0);
            startCarousel();
            var closeBtn = popup.querySelector('.exit-offer-popup__close');
            if (closeBtn) closeBtn.focus();
        }

        function hideExitPopup() {
            if (!exitPopupEl) return;
            exitPopupEl.classList.remove('is-visible');
            document.body.style.overflow = '';
            stopCarousel();
        }

        setTimeout(function () {
            armed = true;
        }, MIN_DWELL_MS);

        document.documentElement.addEventListener('mouseleave', function (e) {
            if (!armed || shown) return;
            if (e.clientY > 12) return;
            showExitPopup();
        });

        document.addEventListener('fluxcold:langchange', function () {
            if (exitPopupEl) refreshExitPopupCopy();
        });
    })();

    (function initCheckoutBailPopup() {
        if (!document.body.classList.contains('template-cart')) return;
        var cartForm = document.getElementById('cart-form');
        if (!cartForm) return;

        var STORAGE_KEY = 'fluxcold_checkout_bail_seen';
        var DISCOUNT_CODE = 'B7XHHXPB1W80';
        var MIN_DWELL_MS = 1500;
        var discountCheckoutUrl = '/discount/' + DISCOUNT_CODE + '?redirect=/checkout';
        var popupEl = null;
        var armed = false;
        var open = false;
        var pendingUrl = null;
        var checkoutBtn = cartForm.querySelector('.cart-summary__checkout, button[name="checkout"]');

        if (sessionStorage.getItem(STORAGE_KEY)) return;

        function markSeen() {
            sessionStorage.setItem(STORAGE_KEY, '1');
        }

        function refreshCheckoutBailCopy() {
            if (!popupEl) return;
            var closeBtn = popupEl.querySelector('.checkout-bail-popup__close');
            if (closeBtn) closeBtn.setAttribute('aria-label', t('productReviews.close'));
            var badge = popupEl.querySelector('.checkout-bail-popup__badge');
            if (badge) badge.textContent = t('checkoutBail.badge');
            var title = popupEl.querySelector('.checkout-bail-popup__title');
            if (title) title.textContent = t('checkoutBail.title');
            var text = popupEl.querySelector('.checkout-bail-popup__text');
            if (text) text.innerHTML = t('checkoutBail.text');
            var codeLabel = popupEl.querySelector('.checkout-bail-popup__code-label');
            if (codeLabel) codeLabel.textContent = t('checkoutBail.codeLabel');
            var copyBtn = popupEl.querySelector('[data-checkout-bail-copy]');
            if (copyBtn && copyBtn.textContent !== t('exitOffer.copied')) copyBtn.textContent = t('checkoutBail.copy');
            var completeBtn = popupEl.querySelector('[data-checkout-bail-complete]');
            if (completeBtn) completeBtn.textContent = t('checkoutBail.complete');
            var leaveBtn = popupEl.querySelector('[data-checkout-bail-leave]');
            if (leaveBtn) leaveBtn.textContent = t('checkoutBail.leave');
        }

        function ensurePopup() {
            if (popupEl) {
                refreshCheckoutBailCopy();
                return popupEl;
            }
            popupEl = document.createElement('div');
            popupEl.id = 'checkoutBailPopup';
            popupEl.className = 'checkout-bail-popup';
            popupEl.setAttribute('role', 'alertdialog');
            popupEl.setAttribute('aria-modal', 'true');
            popupEl.setAttribute('aria-labelledby', 'checkoutBailTitle');
            popupEl.innerHTML =
                '<div class="checkout-bail-popup__backdrop" data-checkout-bail-close></div>' +
                '<div class="checkout-bail-popup__panel">' +
                '  <button type="button" class="checkout-bail-popup__close" data-checkout-bail-close>&times;</button>' +
                '  <div class="checkout-bail-popup__header">' +
                '    <span class="checkout-bail-popup__icon" aria-hidden="true">' +
                '      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">' +
                '        <path d="M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/>' +
                '        <path d="M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/>' +
                '        <path d="M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/>' +
                '      </svg>' +
                '    </span>' +
                '    <span class="checkout-bail-popup__badge"></span>' +
                '    <h2 class="checkout-bail-popup__title" id="checkoutBailTitle"></h2>' +
                '  </div>' +
                '  <div class="checkout-bail-popup__body">' +
                '    <p class="checkout-bail-popup__text"></p>' +
                '    <p class="checkout-bail-popup__code-label"></p>' +
                '    <div class="checkout-bail-popup__code-row">' +
                '      <div class="checkout-bail-popup__code" data-checkout-bail-code>' + DISCOUNT_CODE + '</div>' +
                '      <button type="button" class="checkout-bail-popup__copy" data-checkout-bail-copy></button>' +
                '    </div>' +
                '    <div class="checkout-bail-popup__actions">' +
                '      <button type="button" class="checkout-bail-popup__checkout" data-checkout-bail-complete></button>' +
                '      <button type="button" class="checkout-bail-popup__leave" data-checkout-bail-leave></button>' +
                '    </div>' +
                '  </div>' +
                '</div>';
            document.body.appendChild(popupEl);
            refreshCheckoutBailCopy();

            popupEl.querySelectorAll('[data-checkout-bail-close]').forEach(function (node) {
                node.addEventListener('click', function () {
                    hidePopup(false, true);
                });
            });

            var copyBtn = popupEl.querySelector('[data-checkout-bail-copy]');
            if (copyBtn) {
                copyBtn.addEventListener('click', function () {
                    copyPromoCode(DISCOUNT_CODE, copyBtn);
                });
            }

            var completeBtn = popupEl.querySelector('[data-checkout-bail-complete]');
            if (completeBtn) {
                completeBtn.addEventListener('click', function () {
                    hidePopup(false, true);
                    window.location.href = discountCheckoutUrl;
                });
            }

            var leaveBtn = popupEl.querySelector('[data-checkout-bail-leave]');
            if (leaveBtn) {
                leaveBtn.addEventListener('click', function () {
                    hidePopup(true, true);
                });
            }

            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && popupEl && popupEl.classList.contains('is-visible')) {
                    hidePopup(false, true);
                }
            });

            return popupEl;
        }

        function showPopup(url) {
            if (sessionStorage.getItem(STORAGE_KEY) || open) return;
            open = true;
            pendingUrl = url || null;
            var popup = ensurePopup();
            popup.classList.add('is-visible');
            document.body.style.overflow = 'hidden';
            var completeBtn = popup.querySelector('[data-checkout-bail-complete]');
            if (completeBtn) completeBtn.focus();
        }

        function hidePopup(followPending, permanent) {
            if (!popupEl) return;
            open = false;
            popupEl.classList.remove('is-visible');
            document.body.style.overflow = '';
            if (permanent) markSeen();
            if (followPending && pendingUrl) {
                window.location.href = pendingUrl;
            }
            pendingUrl = null;
        }

        setTimeout(function () {
            armed = true;
        }, MIN_DWELL_MS);

        document.documentElement.addEventListener('mouseleave', function (e) {
            if (!armed || open || sessionStorage.getItem(STORAGE_KEY)) return;
            if (e.clientY > 12) return;
            showPopup(null);
        });

        document.addEventListener('click', function (e) {
            if (open || sessionStorage.getItem(STORAGE_KEY)) return;
            var link = e.target.closest('a[href]');
            if (!link) return;
            if (link.closest('#cart-form')) return;
            if (link.closest('.checkout-bail-popup')) return;
            if (link === checkoutBtn || link.classList.contains('cart-summary__checkout')) return;
            var href = link.getAttribute('href');
            if (!href || href.charAt(0) === '#') return;
            if (link.target === '_blank' || link.hasAttribute('download')) return;
            var dest;
            try {
                dest = new URL(link.href, window.location.href);
            } catch (err) {
                return;
            }
            if (dest.origin !== window.location.origin) return;
            if (dest.pathname === window.location.pathname) return;
            e.preventDefault();
            showPopup(dest.href);
        }, true);

        document.addEventListener('fluxcold:langchange', function () {
            if (popupEl) refreshCheckoutBailCopy();
        });
    })();
})();
